module.exports = __webpack_public_path__ + "static/media/foot.c5eea06f.png";